import {Centre} from "../styled/Center.styled";

function Contact(props) {
    return <Centre>
    <h1>Contact Us</h1>
    <p>To be added soon!!!</p>
</Centre>;
}

export default Contact;